'use strict';

/*
 [
 {
 "beShippingAddressId": 585651,
 "shippingAddressName": "Debbie Test",
 "shippingAddress1": "6225 NE 112th Ave",
 "shippingAddress2": "",
 "shippingAddress3": "",
 "shippingCity": "Portland",
 "shippingCounty": "",
 "shippingState": "OR",
 "shippingPostalCode": "97220-1063",
 "shippingCountry": "US",
 "shippingPhone": "111-111-1111",
 "shippingMobilePhone": "",
 "shippingInstructions": "",
 "shippingAlias": "013113020601",
 "addressType": "",
 "shippingEmail": "",
 "defaultShipping": false
 }
 ]
 */
import angular from 'angular';
import {UserService} from '@nuskin/ns-account';
import {shopModule} from '../module.js';
import {events, RunConfigService, UrlService} from '@nuskin/ns-util';
import {getCachedConfigField} from '@nuskin/configuration-sdk';
import {ShippingAddress, ShopServiceApiVersion} from '@nuskin/ns-shop';

shopModule.factory('nsShipping', ['$resource', 'nsUtil', function($resource, nsUtil) {
    let headers = {
        'client_id': RunConfigService.getRunConfig().clientId,
        'client_secret': RunConfigService.getRunConfig().clientSecret
    };
    let transform = function(data) {
        let object = {};
        if (!nsUtil.isEmpty(data.getBeShippingAddressId())) {
            object.beShippingAddressId=data.getBeShippingAddressId();
        }
        if (!nsUtil.isEmpty(data.getShippingAddressName())) {
            object.shippingAddressName=data.getShippingAddressName();
        }
        const runConfig = RunConfigService.getRunConfig();
        if(!nsUtil.isEmpty(data.getShippingAddress1()) || runConfig.country == 'JP') {
            if(runConfig.country === 'JP' && nsUtil.isEmpty(data.getShippingAddress1())) {
                object.shippingAddress1=' ';
            } else {
                object.shippingAddress1=data.getShippingAddress1();
            }
        }
        if(!nsUtil.isEmpty(data.getShippingAddress2())) {
            object.shippingAddress2=data.getShippingAddress2();
        }
        if(!nsUtil.isEmpty(data.getShippingAddress3)) {
            object.shippingAddress3=data.getShippingAddress3();
        }
        if(!nsUtil.isEmpty(data.getShippingCity())) {
            object.shippingCity=data.getShippingCity();
        }
        if(!nsUtil.isEmpty(data.getShippingCounty())) {
            object.shippingCounty=data.getShippingCounty();
        }
        if(!nsUtil.isEmpty(data.getShippingState())) {
            object.shippingState=data.getShippingState();
        }
        if(!nsUtil.isEmpty(data.getShippingPostalCode())) {
            object.shippingPostalCode=data.getShippingPostalCode();
        }
        if(!nsUtil.isEmpty(data.getShippingCountry())) {
            object.shippingCountry=data.getShippingCountry();
        }
        if(!nsUtil.isEmpty(data.getShippingPhone())) {
            object.shippingPhone=data.getShippingPhone();
        }
        if(!nsUtil.isEmpty(data.getShippingMobilePhone())) {
            object.shippingMobilePhone=data.getShippingMobilePhone();
        }
        if(!nsUtil.isEmpty(data.getShippingInstructions())) {
            object.shippingInstructions=data.getShippingInstructions();
        }
        if(!nsUtil.isEmpty(data.getShippingAlias())) {
            object.shippingAlias=data.getShippingAlias();
        }
        if(!nsUtil.isEmpty(data.getAddressType())) {
            if (data.is711Address === "true"){
                object.addressType='7-11';
            }else{
                object.addressType=data.getAddressType();
            }
        }
        if(!nsUtil.isEmpty(data.getShippingEmail())) {
            object.shippingEmail=data.getShippingEmail();
        }
        if(!nsUtil.isEmpty(data.getDefaultShipping())) {
            object.defaultShipping=data.getDefaultShipping();
        }
        return object;
    };

    let shippingServiceUrl = function() {
        return `${UrlService.getAwsUrl()}/shippingprofile/v1/:sapId`;
    }();

    let getHeaders = function() {
        let user = UserService.getUser();
        if (user) {
            headers.Authorization = `JWT ${user.eid}`;
        }
    };

    let transformShippingQueryResponse = function(data) {
        let addressList = [];

        try {
            let addresses = (JSON.parse(data)).ShippingAddressList;
            angular.forEach(addresses, function (address) {
                // We will change it to match the one we have in the form
                address["saveShippingAddress"] = true;
                let a = new ShippingAddress(address);
                addressList.push(a);
            });
        }
        catch(e){
            console.log("Error - transformShippingQueryResponse couldn't parse the address");
            events.publishError(events.errors.SHIPPING_SERVICE);
        }

        return addressList;
    };

    let transformShippingResponse = function(data) {
        let address = (JSON.parse(data)).ShippingAddress;
        address["saveShippingAddress"] = true;
        return new ShippingAddress(address);
    };

    let shippingRes = $resource(shippingServiceUrl,{},
        {
            'update': {
                method: 'PUT',
                headers: headers,
                transformRequest: function (data) {
                    return JSON.stringify(transform(data));
                },
                transformResponse: transformShippingResponse
            },
            'save': {
                method: 'POST',
                headers: headers,
                transformRequest: function (data) {
                    return JSON.stringify(transform(data));
                },
                transformResponse: transformShippingResponse
            },
            'query': {
                method: 'GET',
                headers: headers,
                isArray: true,
                transformResponse: transformShippingQueryResponse
            },
            'get': {
                method: 'GET',
                headers: headers,
                transformResponse: transformShippingResponse
            },
            'remove': {
                method: 'DELETE',
                headers: headers
            }
        });

    getHeaders();

    // wrapper around the resource object so we can set the updated headers
    return {
        update: (params, object, success, failure) => {
            getHeaders();
            return shippingRes.update(params, object, success, failure);
        },
        save: (params, object, success, failure) => {
            getHeaders();
            return shippingRes.save(params,object, success,failure);
        },
        query: (params, success, failure) => {
            getHeaders();
            return shippingRes.query(params, success, failure);
        },
        get: (params, success, failure) => {
            getHeaders();
            return shippingRes.get(params, success, failure);
        },
        remove: (params, success, failure) => {
            getHeaders();
            return shippingRes.remove(params, success, failure);
        }
    };
}]);


/*
 [
 {
 "id": 21,
 "eventId": 147,
 "startDate": 1398900194000,
 "duration": 1,
 "allowedQty": 321,
 "usedQty": 3,
 "createDate": "2014-04-24"
 }
 ]
 */
shopModule.factory('nsTimeDelivery', ['$resource', function ($resource) {
    return $resource(ShopServiceApiVersion.getDeliveryTimeSlotServiceVersionedUrl(
        getCachedConfigField('deliveryTimeSlotsServiceUrl')
    ));
}]);
